export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/RW-2fedca2ee825adb6f971118ede788ae3.png";